// How someone arrived (brief 035): ?invite=CODE (P-1) or ?ref=share (P-9), kept for
// this browser tab through sign-up and setup. Nothing is sent anywhere; storage can be
// unavailable (private windows), so every access is guarded.
const KEY = 'mxm-arrival';

export const rememberArrival = (search = window.location.search) => {
  const q = new URLSearchParams(search);
  const invite = (q.get('invite') || '').toLowerCase();
  const ref = q.get('ref') || '';
  const next = {};
  if (/^[a-z2-9]{10}$/.test(invite)) next.invite = invite;
  if (ref === 'share') next.ref = 'share';
  if (!Object.keys(next).length) return arrival();
  try { sessionStorage.setItem(KEY, JSON.stringify(next)); } catch { /* storage off */ }
  return next;
};

export const arrival = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch { return {}; }
};

export const clearArrival = () => { try { sessionStorage.removeItem(KEY); } catch { /* storage off */ } };
